import React from "react";
import ContentEvidenceSynopsis from "../../ContentEvidenceSynopsis";

export default function evidenceSynopsisProcessor() {
  const processEvidenceSynopsis = (options) => {
    const { wrapperNode, processNodes, children, evidenceSynopsis } = options;
    const { title } = evidenceSynopsis;
    const content = processNodes(wrapperNode, children);
    return <ContentEvidenceSynopsis content={content} title={title} />;
  };

  return {
    processEvidenceSynopsis,
  };
}
